<!--<ng-container *ngIf="HasRequiredPermissions || true">-->
@if (EntityInstance || isNew()) {
<!-- Conteneur principal avec layout flexbox -->
<div class="flex flex-col h-full">
  <!-- Zone de contenu avec défilement -->
  <div class="{{Skin.detailQrCodeContainer}} flex-1 rounded rounded-lg mb-4">
    <!--  Conteneur desactivable -->
    <div class="{{this.UpdateMode}}">
      <!-- Activity Information Section -->
      @if (!createNewProfile) {
      <h2 class="text-xl text-gray-500 text-center -m-6"> {{ EntityInstance?.trucker?.fullName }}</h2>
      }

      <div>
        <label class="{{Skin.upperCaseSmallLabel}}"> {{ 'vues.qr-code.trucker.last-name' | translate }}</label>
        <input type="text" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'trucker.lastName')"
          class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('trucker.lastName')"
          [disabled]="!this.CanEdit || !createNewProfile" [class.bg-gray-100]="!this.CanEdit || !createNewProfile">
        @if (hasValidationErrors('trucker.lastName')) {
        <div class="text-red-600 text-[11px] p-0 pt-2 -mt-2 -mb-6 relative z-50">
          @for (error of getValidationErrors('trucker.lastName'); track error) {
          <div>{{ error | translate }}</div>
          }
        </div>
        }
      </div>

      <div>
        <label class="{{Skin.upperCaseSmallLabel}}"> {{ 'vues.qr-code.trucker.first-name' | translate }}</label>
        <input type="text" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'trucker.firstName')"
          class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('trucker.firstName')"
          [disabled]="!this.CanEdit || !createNewProfile" [class.bg-gray-100]="!this.CanEdit || !createNewProfile">
        @if (hasValidationErrors('trucker.firstName')) {
        <div class="text-red-600 text-[11px] p-0 pt-2 -mt-2 -mb-6 relative z-50">
          @for (error of getValidationErrors('trucker.firstName'); track error) {
          <div>{{ error | translate}}</div>
          }
        </div>
        }
      </div>

      <div>
        <label class="{{Skin.upperCaseSmallLabel}}"> {{ 'company-name' | translate }}</label>
        <input type="text" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'trucker.companyName')"
          class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('trucker.companyName')"
          [disabled]="!this.CanEdit || !createNewProfile" [class.bg-gray-100]="!this.CanEdit || !createNewProfile">
        @if (hasValidationErrors('trucker.companyName')) {
        <div class="text-red-600 text-[11px] p-0 pt-2 -mt-2 -mb-6 relative z-50">
          @for (error of getValidationErrors('trucker.companyName'); track error) {
          <div>{{ error | translate }}</div>
          }
        </div>
        }
      </div>


      <div>
        <label class="{{Skin.upperCaseSmallLabel}}"> {{ 'email' | translate }}</label>
        <input type="text" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'trucker.email')"
          class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('trucker.email')"
          [disabled]="!this.CanEdit || (!createNewProfile && isEmailLocked) || (createNewProfile && isEmailLocked)"
          [class.bg-gray-100]="!this.CanEdit || (!createNewProfile && isEmailLocked) || (createNewProfile && isEmailLocked)">
        @if (hasValidationErrors('trucker.email')) {
        <div class="text-red-600 text-[11px] p-0 pt-2 -mt-2 -mb-6 relative z-50">
          @for (error of getValidationErrors('trucker.email'); track error) {
          <div>{{ error | translate }}</div>
          }
        </div>
        }
      </div>

      <div>
        <label class="{{Skin.upperCaseSmallLabel}}"> {{ 'cell-phone' | translate }}</label>
        <input type="text" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'trucker.phoneNumber')"
          class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('trucker.phoneNumber')"
          [disabled]="!this.CanEdit || (!createNewProfile && isPhoneNumberLocked) || (createNewProfile && isPhoneNumberLocked)"
          [class.bg-gray-100]="!this.CanEdit || (!createNewProfile && isPhoneNumberLocked) || (createNewProfile && isPhoneNumberLocked)">
        @if (hasValidationErrors('trucker.phoneNumber')) {
        <div class="text-red-600 text-[11px] p-0 pt-2 -mt-2 -mb-6 relative z-50">
          @for (error of getValidationErrors('trucker.phoneNumber'); track error) {
          <div>{{ error | translate }}</div>
          }
        </div>
        }
      </div>

      <!--fin : Zone de saisie du detail d'un trucker-->

      <div>
        <label class="{{Skin.upperCaseSmallLabel}}">
          {{ 'vues.qr-code.truckerActivity.title' | translate }}
        </label>
        @if (!isEditMode()) {
        <div class="p-1 border border-gray-300 rounded-sm bg-gray-50 text-sm">
          {{ EntityInstance?.title }}
        </div>
        } @else {
        <input type="text" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'title')"
          class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('title')"
          [disabled]="!this.CanEdit" [class.bg-gray-100]="!this.CanEdit">
        @if (hasValidationErrors('title')) {
        <div class="text-red-600 text-[11px] p-0 pt-2 -mt-2 -mb-6 relative z-50">
          @for (error of getValidationErrors('title'); track error) {
          <div>{{ error | translate }}</div>
          }
        </div>
        }
        }
      </div>


      <div>
        <label class="{{Skin.upperCaseSmallLabel}}">
          {{
          'vues.qr-code.truckerActivity.deliveryType' | translate
          }}
        </label>
        @if (!isEditMode()) {
        <app-reactive-badge [status]="$safeNavigationMigration(EntityInstance?.deliveryType)" [lookupData]="activityDeliveryTypeLookup()"
          [Skin]="Skin" [isEditMode]="false"></app-reactive-badge>
        } @else {
        <app-reactive-badge [status]="$safeNavigationMigration(editingEntity()?.deliveryType)" [lookupData]="activityDeliveryTypeLookup()"
          [Skin]="Skin" [isEditMode]="true" (statusChange)="onDeliveryTypeChange($event)"></app-reactive-badge>
        @if (hasValidationErrors('deliveryType')) {
        <div class="text-red-600 text-[11px] p-0 pt-2 -mt-2 -mb-6 relative z-50">
          @for (error of getValidationErrors('deliveryType'); track error) {
          <div>{{ error | translate }}</div>
          }
        </div>
        }
        }
      </div>
      <div class="space-y-2 mb-4">
        <label class="{{Skin.upperCaseSmallLabel}}">{{ 'Select Dock' | translate }}</label>
        <select onReady
          [class.bg-yellow-200]="flashingProperty() === 'fK_Dock'"
          class="{{Skin.formInputSmallSize}}"
          (autoBind)="bindingHandler($event, 'fK_Dock')">
          <option [value]="null">{{ 'Choose a dock' | translate }}</option>
          @for (dockOption of filteredDockLookup(); track dockOption.key) {
          <option [value]="dockOption.key">
            {{ dockOption.value }} ({{ dockOption.additionalData['dockstatusname'] | translate }})
          </option>
          }
        </select>
      </div>
      <div class="space-y-2">
        <div>
          <label class="{{Skin.upperCaseSmallLabel}}">{{ 'vues.qr-code.truckerActivity.id' | translate }}</label>
          @if (!isEditMode()) {
          <div class="p-1 border border-gray-300 rounded-sm bg-gray-50 text-sm">
            {{ EntityInstance?.truckerActivityID }}
          </div>
          } @else {
          <input type="text" readonly [readonly]="true" onReady (autoBind)="bindingHandler($event, 'truckerActivityID')"
            class="{{Skin.formInputSmallSize}} bg-gray-100 readonly:pointer-events-none" [class.border-red-500]="hasValidationErrors('truckerActivityID')">
          @if (hasValidationErrors('truckerActivityID')) {
          <div class="text-red-600 text-[11px] p-0 pt-2 -mt-2 -mb-6 relative z-50">
            @for (error of getValidationErrors('truckerActivityID'); track error) {
            <div>{{ error | translate }}</div>
            }
          </div>
          }
          }
        </div>


        <!-- Delivery Information Section -->
        <div class="mt-10">

          <div class="space-y-2">
            <div>
              <label class="{{Skin.upperCaseSmallLabel}}">
                {{
                'entities.truckerActivity.propreties.billOfLanding' | translate
                }}
              </label>
              @if (!isEditMode()) {
              <div class="p-1 border border-gray-300 rounded-sm bg-gray-50 text-sm">
                {{ EntityInstance?.billOfLanding }}
              </div>
              } @else {
              <input type="text" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'billOfLanding')"
                class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('billOfLanding')"
                [disabled]="!this.CanEdit" [class.bg-gray-100]="!this.CanEdit">
              @if (hasValidationErrors('billOfLanding')) {
              <div class="text-red-600 text-[11px] p-0 pt-2 -mt-2 -mb-6 relative z-50">
                @for (error of getValidationErrors('billOfLanding'); track error) {
                <div>{{ error | translate }}</div>
                }
              </div>
              }
              }
            </div>

            <div class="space-y-2 mb-4">
              <label class="{{Skin.upperCaseSmallLabel}}">{{ 'Select Country' | translate }}</label>
              <select class="{{Skin.formInputSmallSize}} block w-full" [ngModel]="selectedCountry()"
                (ngModelChange)="selectedCountry.set($event)" (change)="onCountryChange($event)">
                <option selected value="USA">USA</option>
                <option value="Canada">Canada</option>
              </select>
            </div>

            @if (showSCACPortFields()) {
            <div>
              <label class="{{Skin.upperCaseSmallLabel}}">
                {{
                'entities.truckerActivity.propreties.sCACCode' | translate
                }}
              </label>
              @if (!isEditMode()) {
              <div class="p-1 border border-gray-300 rounded-sm bg-gray-50 text-sm">
                {{ EntityInstance?.sCACCode }}
              </div>
              } @else {
              <input type="text" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'sCACCode')"
                class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('sCACCode')"
                [disabled]="!this.CanEdit" [class.bg-gray-100]="!this.CanEdit">
              @if (hasValidationErrors('sCACCode')) {
              <div class="text-red-600 text-[11px] p-0 pt-2 -mt-2 -mb-6 relative z-50">
                @for (error of getValidationErrors('sCACCode'); track error) {
                <div>{{ error | translate }}</div>
                }
              </div>
              }
              }
            </div>

            <div>
              <label class="{{Skin.upperCaseSmallLabel}}">
                {{
                'entities.truckerActivity.propreties.portOfEntry' | translate
                }}
              </label>
              @if (!isEditMode()) {
              <div class="p-1 border border-gray-300 rounded-sm bg-gray-50 text-sm">
                {{ EntityInstance?.portOfEntry }}
              </div>
              } @else {
              <input type="text" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'portOfEntry')"
                class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('portOfEntry')"
                [disabled]="!this.CanEdit" [class.bg-gray-100]="!this.CanEdit">
              @if (hasValidationErrors('portOfEntry')) {
              <div class="text-red-600 text-[11px] p-0 pt-2 -mt-2 -mb-6 relative z-50">
                @for (error of getValidationErrors('portOfEntry'); track error) {
                <div>{{ error | translate }}</div>
                }
              </div>
              }
              }
            </div>
            }


            <div>
              <label class="{{Skin.upperCaseSmallLabel}}">
                {{
                'entities.truckerActivity.propreties.licenceNumber' | translate
                }}
              </label>
              @if (!isEditMode()) {
              <div class="p-1 border border-gray-300 rounded-sm bg-gray-50 text-sm">
                {{ EntityInstance?.licenceNumber }}
              </div>
              } @else {
              <input type="text" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'licenceNumber')"
                class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('licenceNumber')"
                [disabled]="!this.CanEdit" [class.bg-gray-100]="!this.CanEdit">
              @if (hasValidationErrors('licenceNumber')) {
              <div class="text-red-600 text-[11px] p-0 pt-2 -mt-2 -mb-6 relative z-50">
                @for (error of getValidationErrors('licenceNumber'); track error) {
                <div>{{ error | translate }}</div>
                }
              </div>
              }
              }
            </div>

            <div>
              <label class="{{Skin.upperCaseSmallLabel}}">
                {{
                'entities.truckerActivity.propreties.trailerNumber' | translate
                }}
              </label>
              @if (!isEditMode()) {
              <div class="p-1 border border-gray-300 rounded-sm bg-gray-50 text-sm">
                {{ EntityInstance?.trailerNumber }}
              </div>
              } @else {
              <input type="text" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'trailerNumber')"
                class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('trailerNumber')"
                [disabled]="!this.CanEdit" [class.bg-gray-100]="!this.CanEdit">
              @if (hasValidationErrors('trailerNumber')) {
              <div class="text-red-600 text-[11px] p-0 pt-2 -mt-2 -mb-6 relative z-50">
                @for (error of getValidationErrors('trailerNumber'); track error) {
                <div>{{ error | translate }}</div>
                }
              </div>
              }
              }
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

  <!-- Bandeau pour le nombre d'erreurs -->
  @if (generalErrorCount() > 0) {
  <div class="mb-1 p-1 bg-orange-100 text-red-700 border border-orange-300 rounded-full text-xs sticky bottom-14 z-10 py-1 -mt-1 z-20 text-center">
    <i class="fas fa-exclamation-triangle mr-1 ml-2"></i>
    {{ generalErrorCount() }} erreur(s) dans le formulaire
  </div>
  }
</div>
}

<!--</ng-container>-->